import { Content } from '../../types';

export const lumphiniParkContent: Content = {
  title: 'פארק לומפיני Lumphini Park',
  imageUrl: '/images/thailand/lumphini/lumphini-wide.jpeg',
  introduction: `פארק לומפיני (Lumphini Park) הינו הפארק הציבורי הגדול והמרכזי ביותר בבנגקוק, המשתרע על פני כ-575 דונם של שטחים ירוקים בלב העיר הסואנת. הפארק נקרא על שם לומביני שבנפאל, מקום הולדתו של הבודהה, ונוסד בשנות ה-20 של המאה ה-20 על ידי המלך ראמה השישי, אשר רצה ליצור מרחב ירוק לתושבי העיר.`,
  sections: [
    {
      title: 'אטרקציות ופעילויות בפארק',
      type: 'sub-headers',
      description:
        'פארק לומפיני מהווה מקום מפלט פסטורלי מהמולת העיר ומציע מגוון אפשרויות לפנאי, ספורט ורגיעה:',
      content: [
        {
          subtitle: 'אגם מלאכותי',
          text: 'בלב הפארק שוכן אגם גדול, בו ניתן לשכור סירות פדלים בצורת ברבורים ולשוט בנחת.',
        },
        {
          subtitle: 'מסלולי הליכה וריצה',
          text: 'מסלול מעגלי של כ-2.5 ק"מ מקיף את הפארק, מה שהופך אותו למקום פופולרי לרצים, הולכי רגל ורוכבי אופניים (רכיבה מותרת רק בשעות הבוקר עד שעות הצהריים המוקדמות).',
        },
        {
          subtitle: 'מתקני כושר ציבוריים',
          text: 'ברחבי הפארק פזורים מתקני כושר פתוחים לשימוש חופשי, לצד אזורים ייעודיים לאימונים קבוצתיים.',
        },
        {
          subtitle: "שיעורי טאי-צ'י ופעילויות ספורט",
          text: "בשעות הבוקר המוקדמות ניתן לראות קבוצות מקומיות מתאמנות בטאי-צ'י, יוגה או זומבה, דבר שהפך למסורת בקרב מבקרים רבים.",
        },
        {
          subtitle: 'מרכזי קהילה ואירועים',
          text: 'לעיתים מתקיימים בפארק קונצרטים, מופעים ואירועים ציבוריים, בעיקר בסופי שבוע.',
        },
        {
          subtitle: 'צפייה בלטאות כוח (Monitor Lizards)',
          text: 'אחד המאפיינים הייחודיים של הפארק הוא אוכלוסיית לטאות הכוח הגדולות, המסתובבות בו באופן חופשי. הלטאות אינן מסוכנות אך מומלץ לשמור מרחק מהן.',
        },
      ],
    },
    {
      title: 'שעות פתיחה',
      type: 'text',
      content:
        'הפארק פתוח לקהל הרחב בין השעות 05:00 עד 22:00, כאשר שעות הבוקר המוקדמות הן הזמן האידיאלי לביקור, במיוחד אם רוצים להימנע מהחום הכבד של היום.',
    },
    {
      title: 'דרכי הגעה',
      type: 'sub-headers',
      description: 'ניתן להגיע לפארק בקלות באמצעות מגוון אמצעי תחבורה:',
      content: [
        {
          subtitle: 'רכבת עילית (BTS)',
          text: 'תחנת Sala Daeng על קו סילום.',
        },
        {
          subtitle: 'רכבת תחתית (MRT)',
          text: 'תחנת Silom או תחנת Lumphini.',
        },
        {
          subtitle: 'אוטובוסים ומוניות',
          text: 'הפארק נגיש גם דרך מערך האוטובוסים והמוניות של העיר.',
        },
        {
          subtitle: '',
          text: 'לאחרונה אף נפתח שביל הולכי רגל ואופניים, באורך של כ - 1.3 ק"מ, המחבר את הפארק עם פארק בנצ׳קיטי Benchakitti Park עליו דיברנו בפוסט קודם, מצב המאפשר טיול משולב בשני הפארקים יחדיו.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, פארק לומפיני הינו ריאה ירוקה ייחודית בלב בנגקוק, המספקת לתושבים ולמבקרים מקום מפלט מהעיר הסואנת. בין אם אתם מחפשים מקום לריצה, טיול נינוח, אימון גופני, או סתם פינה שקטה לנוח בה - פארק זה הינו בחירה מעולה!`,
      type: 'text',
      isBold: true,
    },
  ],
};
